import styled from "styled-components";

export const MenuTrainingMainStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 24px;
`;
